import * as pbi from 'powerbi-client'
import axios from 'axios'
import Cookies from 'js-cookie'
import store from '@state/store'

export default {
  async getEmbedInfo() {
    var embedInfo
    var currentDate = new Date()
    if (localStorage.getItem('embed_info')) {
      embedInfo = JSON.parse(localStorage.getItem('embed_info'))
      // check expiration date of embed code
      var expirationDate = new Date(embedInfo.embedToken.expiration)
      var delta = (expirationDate.getTime() - currentDate.getTime()) / 1000
      if (delta < 0) {
        embedInfo = undefined
      } else {
        store.commit('users/SET_EMBED_INFO', embedInfo)
      }
    }
    if (embedInfo === undefined) {
      var repNumber
      if (store.getters['user/userRepNum']) {
        repNumber = store.getters['user/userRepNum']
      } else {
        repNumber = Cookies.get('repNumber')
      }
      if (!repNumber) {
        // if there is no rep number
        var lastAuthRetryDate = Cookies.get('lastAuthRetry')
          ? new Date(Cookies.get('lastAuthRetry'))
          : undefined
        if (
          !lastAuthRetryDate ||
          (lastAuthRetryDate instanceof Date &&
            !isNaN(lastAuthRetryDate) &&
            new Date(lastAuthRetryDate.getTime() + 120000) < currentDate)
        ) {
          // if we havent retried the auth yet, try clearing cookies and refresh
          Object.keys(Cookies.get()).forEach(function (cookieName) {
            if (cookieName !== 'lastAuthRetry') {
              Cookies.remove(cookieName)
            }
          })
          Cookies.set('lastAuthRetry', new Date().toISOString())
          location.reload()
        } else {
          // if we have already tried reauth, give up

          console.error(
            'Rep Number not found. Reauth attempt failed. Request for embed code canceled.'
          )
          embedInfo = {
            embedReport: [],
            embedToken: {},
            type: 'Report',
          }
        }
      } else {
        var request = {
          workspaceId: process.env.VUE_APP_WORKSPACE_ID,
          datasetWorkspaceId: process.env.VUE_APP_DATASET_WORKSPACE_ID,
          reports: [
            process.env.VUE_APP_REPORT_ID_BIOSTIM,
            process.env.VUE_APP_REPORT_ID_DIRECTORY,
            process.env.VUE_APP_REPORT_ID_HOME,
            process.env.VUE_APP_REPORT_ID_SALES,
          ],
          repNumber: repNumber,
        }
        await axios
          .post(process.env.VUE_APP_EMBED_GENERATOR_URL, request, {
            headers: {
              'Access-Control-Allow-Origin': '*',
              'Access-Control-Allow-Methods':
                'GET, POST, PATCH, PUT, DELETE, OPTIONS',
              'Access-Control-Allow-Headers':
                'Origin, Content-Type, X-Auth-Token',
            },
          })
          .then(
            (response) => {
              embedInfo = response.data.value
              store.commit('users/SET_EMBED_INFO', embedInfo)
            },
            (error) => {
              console.error(error)
            }
          )
      }
    }
    return embedInfo
  },

  async getReportConfig(embedInfo, reportId) {
    if (!(await this.validateToken(embedInfo))) {
      embedInfo.token = JSON.parse(
        localStorage.getItem('embed_info')
      ).embedToken.token
    }
    var config = {
      type: 'report',
      tokenType: pbi.models.TokenType.Embed,
      accessToken: embedInfo.token,
      embedUrl:
        embedInfo.embedReports[
          embedInfo.embedReports.findIndex(
            (x) => x.reportId === reportId.toString()
          )
        ].embedUrl,
      id: reportId.toString(),
      permissions: pbi.models.Permissions.All,
      settings: {
        filterPaneEnabled: true,
        navContentPaneEnabled: true,
      },
    }
    return config
  },
  async validateToken(embedInfo) {
    if (new Date().getTime() >= Date.parse(embedInfo.expiration)) {
      localStorage.removeItem('embed_info')
      await this.getEmbedInfo().then(() => {
        return false
      })
    } else {
      return true
    }
  },
  requestReportExport(reportId) {
    var repNumber
    if (store.getters['user/userRepNum']) {
      repNumber = store.getters['user/userRepNum']
    } else {
      repNumber = Cookies.get('repNumber')
    }
    return axios.post(
      process.env.VUE_APP_REQUEST_EXPORT_URL,
      {
        workspaceId: process.env.VUE_APP_WORKSPACE_ID,
        reportId: reportId,
        repNumber: repNumber,
      },
      {
        headers: {
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Methods':
            'GET, POST, PATCH, PUT, DELETE, OPTIONS',
          'Access-Control-Allow-Headers': 'Origin, Content-Type, X-Auth-Token',
        },
      }
    )
  },
  getExportStatus(reportId, exportId) {
    return axios.post(
      process.env.VUE_APP_EXPORT_STATUS_URL,
      {
        workspaceId: process.env.VUE_APP_WORKSPACE_ID,
        reportId: reportId,
        exportId: exportId,
      },
      {
        headers: {
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Methods':
            'GET, POST, PATCH, PUT, DELETE, OPTIONS',
          'Access-Control-Allow-Headers': 'Origin, Content-Type, X-Auth-Token',
        },
      }
    )
  },
  downloadExport(reportId, exportId) {
    return axios.post(
      process.env.VUE_APP_DOWNLOAD_EXPORT_URL,
      {
        workspaceId: process.env.VUE_APP_WORKSPACE_ID,
        reportId: reportId,
        exportId: exportId,
      },
      {
        headers: {
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Methods':
            'GET, POST, PATCH, PUT, DELETE, OPTIONS',
          'Access-Control-Allow-Headers': 'Origin, Content-Type, X-Auth-Token',
        },
      }
    )
  },
}
